import { idb } from "../../idb.js";
import { logRetentionDays } from "./data/log-config.js";
import { loggingContexts } from "./data/logging-contexts.js";
import { log } from "./log.js";

const pruneLogEntriesLog = log(loggingContexts.pruneLogs);

const millisecondsInADay = 24 * 60 * 60 * 1000;

const cutoffTimestamp = () =>
  new Date(Date.now() - logRetentionDays * millisecondsInADay).toISOString();

export const pruneLogEntries = async () => {
  let connection;

  try {
    connection = await idb();
  } catch (error) {
    pruneLogEntriesLog.warn(
      "could not open IDB; skipping log entry pruning this tick",
      error?.message
    );

    return 0;
  }

  const cutoff = cutoffTimestamp();

  const transaction = connection.transaction("logs", "readwrite");
  const index = transaction.store.index("timestamp");

  let deleted = 0;
  let cursor = await index.openCursor(IDBKeyRange.upperBound(cutoff, true));

  while (cursor) {
    await cursor.delete();
    deleted += 1;
    cursor = await cursor.continue();
  }

  await transaction.done;

  if (deleted > 0) {
    pruneLogEntriesLog.info(
      "pruned idb log entries:",
      deleted,
      "older than",
      cutoff
    );
  }

  return deleted;
};
